/** Mirrors tma-be `src/prediction/data-health.service.ts`. */

/** What a gap in the data breaks. Sections of the Data Health page, in display order. */
export enum HealthImpact {
  VISIBILITY = "visibility",
  PLANNING = "planning",
  VEHICLE = "vehicle",
  ORIGIN = "origin",
  ACCESS = "access",
}

export const HEALTH_IMPACTS: HealthImpact[] = [
  HealthImpact.VISIBILITY,
  HealthImpact.PLANNING,
  HealthImpact.VEHICLE,
  HealthImpact.ORIGIN,
];

export enum HealthCheckKey {
  SUB_CLIENT_NO_COORDINATES = "sub_client_no_coordinates",
  STATUS_NO_TYPE = "status_no_type",
  NO_INTERNAL_STATUS = "no_internal_status",
  NO_AT_CUSTOMER_STATUS = "no_at_customer_status",
  ITEM_NO_CATEGORY = "item_no_category",
  SUB_CLIENT_NO_TARGET = "sub_client_no_target",
  CATEGORY_NO_SPECS = "category_no_specs",
  VEHICLE_MODEL_NO_CAPACITY = "vehicle_model_no_capacity",
  VEHICLE_NO_SITE = "vehicle_no_site",
  VEHICLE_NO_DRIVER = "vehicle_no_driver",
  SITE_NO_COORDINATES = "site_no_coordinates",
  /** TMA-side checks, shown on Client Detail only. */
  DEVICE_NO_SITE = "device_no_site",
  GEOFENCE_NOT_SET = "geofence_not_set",
  PRV_PAUSED = "prv_paused",
  NO_ACTIVE_USER = "no_active_user",
}

/** Who can close the gap: the client's own users, or a TMA admin on Client Detail. */
export type HealthFixer = "client" | "tma";

export interface HealthRow {
  /** Record id, or the status value for status checks. */
  id: number | string;
  name: string;
  /** Column names still empty on this record. Empty when the record itself is missing. */
  fields: string[];
  /** Dependent records behind this one (items in a status, vehicles of a model). */
  count: number | null;
}

export interface HealthCheck {
  key: HealthCheckKey;
  impact: HealthImpact;
  fixedBy: HealthFixer;
  /** Exact total; `rows` is capped. */
  count: number;
  rows: HealthRow[];
  truncated: boolean;
}

export interface DataHealthReport {
  checkedAt: string;
  /** Sum of every check's count. Zero means all clear. */
  openCount: number;
  checks: HealthCheck[];
  passing: HealthCheckKey[];
}
